import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// import { ethers, HDNodeWallet } from 'ethers';
import SHA256 from 'crypto-js/sha256';
import { ethers, HDNodeWallet, Mnemonic } from 'ethers';
import logo from '../assets/logo.png';

const Welcome = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [agree, setAgree] = useState(false);
  const [mnemonicInput, setMnemonicInput] = useState('');
  const [confirmInput, setConfirmInput] = useState('');
  const [generatedMnemonic, setGeneratedMnemonic] = useState('');
  const [mode, setMode] = useState('');
  const [step, setStep] = useState(1);

  const handleCreateStep1 = () => {
    if (!agree || !password) return alert('Lütfen şifre girin ve onay kutusunu işaretleyin.');

    const wallet = ethers.Wallet.createRandom();
    const mnemonic = wallet.mnemonic.phrase;
    setGeneratedMnemonic(mnemonic);
    setStep(2);
  };

  const handleCreateStep2 = () => {
	  // handleCreateStep2 içinde:

    const trimmedConfirm = confirmInput.trim().toLowerCase().replace(/\s+/g, ' ');
    const original = generatedMnemonic.trim().toLowerCase().replace(/\s+/g, ' ');
    if (trimmedConfirm !== original) return alert('12 kelime doğru girilmedi!');

	const mnemonicObj = Mnemonic.fromPhrase(original);
	const wallet = HDNodeWallet.fromMnemonic(mnemonicObj);

    // const wallet = HDNodeWallet.fromMnemonic(original);
    const hashedPassword = SHA256(password).toString();
    localStorage.setItem('wallet_hash', hashedPassword);
    localStorage.setItem('wallet_mnemonic', wallet.mnemonic.phrase);
    localStorage.setItem('wallet_address', wallet.address);
    alert('Cüzdan başarıyla oluşturuldu: ' + wallet.address);
    // navigate('/');
	 window.location.href = '/dashboard'; 
  };

  const handleImportWallet = () => {
    if (!agree || !password || !mnemonicInput) return alert('Tüm alanlar zorunlu');
    try {
	  // handleImportWallet içinde:
		const mnemonicObj = Mnemonic.fromPhrase(mnemonicInput.trim());
		const wallet = HDNodeWallet.fromMnemonic(mnemonicObj);
      // const wallet = HDNodeWallet.fromMnemonic(mnemonicInput.trim());
      const hashedPassword = SHA256(password).toString();

      localStorage.setItem('wallet_hash', hashedPassword);
      localStorage.setItem('wallet_mnemonic', wallet.mnemonic.phrase);
      localStorage.setItem('wallet_address', wallet.address);
      alert('Cüzdan Aktarıldı: ' + wallet.address);
      // navigate('/dashboard');
	   window.location.href = '/dashboard'; 
    } catch (e) {
      alert('Geçersiz Güvenlik Kelimesi!');
    }
  };

  return (
    <div className="welcome-desing">
	<img src={logo} alt="Etagram Logo" style={{ width: 120, marginBottom: 20 }} />
      <h1>Etagram Cüzdan'a Hoş Geldin</h1>

      {!mode && (
        <div>
          <button onClick={() => setMode('create')} >
            Yeni Cüzdan Oluştur
          </button>
          <button onClick={() => setMode('import')} >
            Cüzdanı İçe Aktar
          </button>
        </div>
      )}

      {mode === 'create' && step === 1 && (
        <div>
          <input
            type="password"
            placeholder="Şifre oluştur"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <label>
            <input type="checkbox" checked={agree} onChange={() => setAgree(!agree)} />
            <span>
              <a href="/terms"  target="_blank" rel="noopener noreferrer">
                Kullanım koşullarını
              </a>{' '}
              kabul ediyorum
            </span>
          </label>
          <button
            onClick={handleCreateStep1}
            disabled={!agree || !password}
          >
            Devam Et
          </button>
        </div>
      )}

      {mode === 'create' && step === 2 && (
        <div>
          <p>
            📄 <strong>Güvenlik (12 kelime):</strong><br />
            <code>{generatedMnemonic}</code>
          </p>
          <textarea
            placeholder="Lütfen yukarıdaki 12 kelimeyi tekrar sırayla girin"
            value={confirmInput}
            onChange={(e) => setConfirmInput(e.target.value)}           
            rows={4}
          />
          <button
            onClick={handleCreateStep2}
          >
            Oluşturmayı Tamamla
          </button>
        </div>
      )}

      {mode === 'import' && (
        <div>
          <textarea
            placeholder="12 kelimelik güvelik buraya..."
            value={mnemonicInput}
            onChange={(e) => setMnemonicInput(e.target.value)}          
            rows={4}
          />
          <input
            type="password"
            placeholder="Şifre oluştur"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <label >
            <input type="checkbox" checked={agree} onChange={() => setAgree(!agree)} />
            <span>
              <a href="/terms" target="_blank" rel="noopener noreferrer">
                Kullanım koşullarını
              </a>{' '}
              kabul ediyorum
            </span>
          </label>
          <button
            onClick={handleImportWallet}
            disabled={!agree || !password || !mnemonicInput}
          >
            Cüzdanı Aktar
          </button>
        </div>
      )}
    </div>
  );
};

export default Welcome;
